/** 热窗口里的月末快照(元)。 */
type Data = Record<string, unknown>;
const object = (v: unknown): Data | null => v != null && typeof v === 'object' && !Array.isArray(v) ? v as Data : null;
const when = (v: unknown): string => typeof v === 'number' && Number.isSafeInteger(v) && v >= 0 && v <= 0xffffffff
  ? `第 ${Math.floor(v / 360) + 1} 年 ${Math.floor(v % 360 / 30) + 1} 月 ${v % 30 + 1} 日（游戏日 ${v}）` : '未记录';
export const MONTH_SNAPSHOTS_TITLE = '最近的月末快照';
export function monthSnapshotsText(value: unknown): string[] {
  const audit = object(value), lines = [MONTH_SNAPSHOTS_TITLE, '和上面月账同一天结账的是同一期。'];
  if (!Array.isArray(audit?.months)) return [...lines, '未记录'];
  if (!audit.months.length) return [...lines, '没有'];
  const yuan = audit.moneyUnit === 'yuan';
  const amount = (v: unknown, precise = false) => yuan && typeof v === 'number' && Number.isFinite(v)
    ? `${precise ? String(v) : v.toFixed(2)} 元` : '未知';
  if (!yuan) lines.push('金额单位未记录，金额见附录。');
  lines.push('流入、流出含资产买卖和借还,不含本人存取款。');
  for (const item of audit.months) {
    const m = object(item) ?? {};
    lines.push('', `结账日：${when(m.day)}`,
      `现金 ${amount(m.cash)} · 存款 ${amount(m.deposit)} · 现金及存款账面合计 ${amount(m.liquid)}`,
      `房产期末估值 ${amount(m.property)} · 登记股份期末估值 ${amount(m.shares)} · 其他经营权益 ${amount(m.business)} · 土地 ${amount(m.land)}`,
      `期房 ${amount(m.presales)} · 在建权益 ${amount(m.construction)} · 贷款本金 ${amount(m.debt)} · 净资产 ${amount(m.netWorth)}`,
      `本期实际流入 ${amount(m.in)} · 本期实际流出 ${amount(m.out)}`,
      `上期：${when(m.beforeDay)} · 净资产 ${amount(m.beforeWorth)}`,
      `资产账差 ${amount(m.balanceDifference, true)} · 资金账差 ${amount(m.liquidDifference, true)}`,
      ...(typeof m.scope === 'string' && m.scope.trim() ? [`口径：${m.scope}`] : []));
  }
  return lines;
}
